import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import { FooterSettings, LoadingSettings, State } from "@/models";

Vue.use(Vuex);

const state: State = {
  footerSettings: {
    variant: 0,
    loading: false,
    prevText: "",
    prevIcon: "",
    prevAction: undefined,
    prevVisible: false,
    prevEnabled: false,
    nextText: "",
    nextIcon: "",
    nextAction: undefined,
    nextVisible: false,
    nextEnabled: false
  },
  loadingSettings: {
    loading: false,
    loadingText: "",
    transition: ""
  },
  wrinkles: 1,
  age: 1,
  questionnaire: 1,
  product: 1
};

const mutations = {
  changeFooter(state: State, newSettings: FooterSettings): void {
    state.footerSettings = newSettings;
  },
  setLoading(state: State, newSettings: LoadingSettings): void {
    state.loadingSettings.loading = newSettings.loading;
    state.loadingSettings.loadingText = newSettings.loadingText;
    state.loadingSettings.transition = newSettings.transition
      ? newSettings.transition
      : state.loadingSettings.transition;
  },
  setWrinkles(state: State, value: number): void {
    state.wrinkles = value;
  },
  setAge(state: State, value: number): void {
    state.age = value;
  },
  setQuestionnaire(state: State, value: number): void {
    state.questionnaire = value;
  },
  setProduct(state: State, value: number): void {
    state.product = value;
  },
  resetValues(state: State): void {
    state.wrinkles = 1;
    state.age = 1;
    state.questionnaire = 1;
    state.product = 1;
  }
};

export default new Vuex.Store({
  state,
  mutations,
  plugins: [createPersistedState()]
});
